import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function Protected({ children, roles }) {
  const { user, ready } = useAuth();
  const loc = useLocation();
  if (!ready) {
    return (
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="moe-shimmer h-8 w-64 mb-4" />
        <div className="moe-shimmer h-4 w-96 mb-2" />
        <div className="moe-shimmer h-4 w-80" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
